export default function selectGgEnvironment(state): SensoryLinkEnvironment | null {
  return state.ggEnvironment;
}